import { useState } from 'react';
import { Button, TextField, Typography, useTheme } from '@material-ui/core';

// Character counter tool that will count the number of characters in a text input
export const CharacterCounter = () => {
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [input, setInput] = useState('');

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInput(value);
  };

  const handleClear = () => {
    setInput('');
  };

  return (
    <div>
      <TextField
        label="Enter text"
        variant="outlined"
        value={input}
        onChange={handleInputChange}
        fullWidth
        multiline
        rows={4}
        style={{
          backgroundColor: isDark
            ? theme.palette.background.paper
            : theme.palette.background.default,
        }}
      />
      <Typography variant="body2" style={{ marginTop: '8px' }}>
        Character count: {input.length}
      </Typography>
      <Button
        variant="outlined"
        style={{ color: theme.palette.secondary.main, marginTop: '16px' }}
        onClick={handleClear}
        disabled={input.length === 0}
      >
        Clear
      </Button>
    </div>
  );
};

export default CharacterCounter;
